import { axios } from '@/plugins/axios-pol'

export default {
  namespaced: true,

  state: {
    catEstatusIntervencion: [],
  },

  getters: {
    getCatEstatusIntervencion: (state) => {
      return state.catEstatusIntervencion
    },
  },

  mutations: {
    SET_CAT_ESTATUS_INTERVENCION(state, catEstatusIntervencion) {
      state.catEstatusIntervencion = catEstatusIntervencion
    },
  },

  actions: {
    fetchCatEstatusIntervencion: async function ({ commit }) {
      try {
        const response = await axios.get('/personal/api/EstadoFuerza/catEstatusIntervencion')
        commit('SET_CAT_ESTATUS_INTERVENCION', response.data.data)
      } catch (error) {
        console.error('[catEstatusIntervencion] fetchCatEstatusIntervencion failed:', error)
        throw error
      }
    },
  },
}
